import React, { useMemo } from 'react';

import numberFormatter from '../../../common/numberFormatter';
import { CreateUpdateOrderExecutionDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import mathUtils from '../../../utils/mathUtils';
import { CurrencyIsoTypeEnum } from '../../../common/pokCore/validation/enums';
import { useTranslation } from '../../../common/hooks/useTranslation';

const OrderExecutionPositionsSumRow = ({
  orderExecution,
  positionsSalesSum,
  purchaseSum,
  isDecisionView,
  isActionGroupAvailable,
  currencyCode,
}: {
  orderExecution: CreateUpdateOrderExecutionDto;
  isActionGroupAvailable?: boolean;
  positionsSalesSum: number;
  purchaseSum?: number;
  isDecisionView?: boolean;
  currencyCode?: string;
}) => {
  const { t, tk } = useTranslation('orderLng');
  const positionsSum = useMemo(
    () =>
      mathUtils.add(
        ...orderExecution.orderExecutionPositions.map(({ amount }) =>
          mathUtils.round(amount),
        ),
      ),
    [orderExecution.orderExecutionPositions],
  );

  return (
    <>
      <tr className="align-middle">
        <td
          style={{ textAlign: 'end' }}
          colSpan={isActionGroupAvailable ? 4 : 3}
        >
          <b>{t(tk.common.sum)}</b>
        </td>
        <td>
          <b>
            {numberFormatter(
              positionsSum,
              true,
              (currencyCode as CurrencyIsoTypeEnum) || undefined,
            )}
          </b>
        </td>
      </tr>
      <tr className="align-middle">
        <td
          style={{ textAlign: 'end' }}
          colSpan={isActionGroupAvailable ? 4 : 3}
        >
          {t(tk.prLang.estimatePositionsSum)}
        </td>
        <td>
          {numberFormatter(
            isDecisionView ? purchaseSum || 0 : positionsSalesSum,
            true,
            isDecisionView ? undefined : (currencyCode as CurrencyIsoTypeEnum),
          )}
        </td>
      </tr>
    </>
  );
};

export default OrderExecutionPositionsSumRow;
